export default __webpack_public_path__ + "static/media/pic4.890eaa89.jpg";